import { FC } from "react";
import { Spinner } from "react-bootstrap";

interface PageLoaderProps {
  message?: string;
}

/** In-layout loader for route lazy chunks and table areas (not full-screen). */
const PageLoader: FC<PageLoaderProps> = ({ message = "Loading..." }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center flex-grow-1 p-5 text-secondary"
    role="status"
    aria-live="polite"
  >
    <Spinner animation="border" variant="primary" />
    <span className="visually-hidden">{message}</span>
    <span className="mt-3 fs-14">{message}</span>
  </div>
);

export default PageLoader;
